const SET_GRADE_ID = "SET_GRADE_ID"
const SET_STORY_ID = "SET_STORY_ID"
const SET_IS_ON_PAGES = "SET_IS_ON_PAGES"
const SET_IS_ON_HOME = "SET_IS_ON_HOME"
const INCREMENT_CURRENT_PAGE = "INCREMENT_CURRENT_PAGE"
const DECREMENT_CURRENT_PAGE = "DECREMENT_CURRENT_PAGE"

export {SET_GRADE_ID,SET_STORY_ID, INCREMENT_CURRENT_PAGE, DECREMENT_CURRENT_PAGE, SET_IS_ON_PAGES, SET_IS_ON_HOME}